import { useAction } from 'next-safe-action/hooks'

import { removeFromFavoriteList } from '@/entities/room'
import { useServerErrorHandler } from '@/shared/config'

type RemoveFromFavoriteListActionProps = {
  onSuccess: () => void
}

export const useRemoveFromFavoriteList = ({
  onSuccess,
}: RemoveFromFavoriteListActionProps) => {
  const { handleServerError } = useServerErrorHandler()

  const action = useAction(removeFromFavoriteList, {
    onSuccess: () => {
      onSuccess()
    },
    onError: ({ error }) => {
      if (error.serverError) {
        handleServerError(error.serverError)
      }
    },
  })

  return action
}
